module.exports = __webpack_public_path__ + "img/tnb.af3f37f6.svg";